import { FormInfoGroup } from 'src/app/admin/admin-home/forms/shared-components/form-info-group';
import { ValueListItem } from '../valueListItem';

export class ApplicationField {
  public fieldName: ApplicationFieldName;
  public displayStatus: ApplicationFieldDisplayStatus;
  public category: FormInfoGroup;
  public valueList: ValueListItem[];
  public customLabel: string;

  private _fieldRequiresPlanUpgrade: boolean;
  private _disabledBySystemSetting: boolean;
  constructor() {}
  public static parse(
    data: any,
    fieldRequiresPlanUpgrade = false,
    disabledBySystemSetting = false
  ): ApplicationField {
    if (!data) return null;

    const applicationField = new ApplicationField();
    Object.assign(applicationField, data);
    applicationField._fieldRequiresPlanUpgrade = fieldRequiresPlanUpgrade;
    applicationField._disabledBySystemSetting = disabledBySystemSetting;
    applicationField.category = ApplicationField.getCategory(applicationField.fieldName);
    return applicationField;
  }

  public get isRequired() {
    if (this._fieldRequiresPlanUpgrade || this._disabledBySystemSetting) return false;
    return this.displayStatus == ApplicationFieldDisplayStatus.Required;
  }

  public set isRequired(value) {
    value
      ? (this.displayStatus = ApplicationFieldDisplayStatus.Required)
      : (this.displayStatus = ApplicationFieldDisplayStatus.Optional);
  }

  public get isVisible() {
    if (this._fieldRequiresPlanUpgrade || this._disabledBySystemSetting) return false;
    return this.displayStatus != ApplicationFieldDisplayStatus.Hidden;
  }

  public set isVisible(value) {
    value
      ? (this.displayStatus = ApplicationFieldDisplayStatus.Optional)
      : (this.displayStatus = ApplicationFieldDisplayStatus.Hidden);
  }

  public get disabledBySystemSetting() {
    return this._disabledBySystemSetting;
  }

  /** Only Team Name and Team Public Name system fields support a custom display label. */
  public get canCustomizeLabel() {
    return (
      this.fieldName == ApplicationFieldName.TeamName ||
      this.fieldName == ApplicationFieldName.TeamPublicName
    );
  }

  private static getCategory(fieldName: ApplicationFieldName): FormInfoGroup {
    if (fieldName == ApplicationFieldName.Gender || fieldName == ApplicationFieldName.Race) {
      return FormInfoGroup.DemographicInfo;
    }
    if (
      fieldName == ApplicationFieldName.JobTitle ||
      fieldName == ApplicationFieldName.Company ||
      fieldName == ApplicationFieldName.LinkedIn ||
      fieldName == ApplicationFieldName.Resume
    ) {
      return FormInfoGroup.ProfessionalInfo;
    }
    if (
      fieldName == ApplicationFieldName.TeamName ||
      fieldName == ApplicationFieldName.TeamPublicName
    ) {
      return FormInfoGroup.TeamInfo;
    }
    return fieldName == ApplicationFieldName.Avatar ||
      fieldName == ApplicationFieldName.PhoneNumber ||
      fieldName == ApplicationFieldName.Suffix ||
      fieldName == ApplicationFieldName.Prefix ||
      fieldName == ApplicationFieldName.MiddleName
      ? FormInfoGroup.ContactInfo
      : FormInfoGroup.MailingAddress;
  }
}

export enum ApplicationFieldName {
  Address1 = 'Address1',
  Address2 = 'Address2',
  City = 'City',
  StateOrProvince = 'StateOrProvince',
  PostalCode = 'PostalCode',
  Country = 'Country',
  JobTitle = 'JobTitle',
  Company = 'Company',
  Resume = 'Resume',
  PhoneNumber = 'PhoneNumber',
  Avatar = 'Avatar',
  Gender = 'Gender',
  Race = 'Race',
  LinkedIn = 'LinkedIn',
  MiddleName = 'MiddleName',
  AddressIsShared = 'AddressIsShared',
  Prefix = 'Prefix',
  Suffix = 'Suffix',
  TeamName = 'TeamName',
  TeamPublicName = 'TeamPublicName'
}

export enum ApplicationFieldDisplayStatus {
  Optional = 'Optional',
  Required = 'Required',
  Hidden = 'Hidden'
}
